import * as R from 'ramda';
import { IProductDetailsGridParams } from '../../../../../../../../services/modules/productDetails/productDetails.types';
import { CompactAvailability } from '../../../../../../ProductTypes';

type AvailabilityGridParams = Pick<
  IProductDetailsGridParams,
  'availability' | 'deliveryWindowIds' | 'deliveryWindowsSnapshot'
>;

interface ToggledAvailabilityGridParams extends Omit<AvailabilityGridParams, 'availability'> {
  availability: CompactAvailability | undefined;
}

interface ToggleAvailabilityGridParamsParams {
  toggled: CompactAvailability;
  current: AvailabilityGridParams;
}

export const toggleAvailabilityGridParams = ({
  toggled,
  current,
}: ToggleAvailabilityGridParamsParams): ToggledAvailabilityGridParams => {
  const isAllAvailabilitiesSelected = R.isNil(current.availability);
  const oppositeAvailability =
    toggled === CompactAvailability.PRE_ORDER
      ? CompactAvailability.READY_FOR_DELIVERY
      : CompactAvailability.PRE_ORDER;
  const availability = isAllAvailabilitiesSelected ? oppositeAvailability : undefined;

  if (toggled === CompactAvailability.PRE_ORDER) {
    return { availability, deliveryWindowIds: undefined, deliveryWindowsSnapshot: undefined };
  }

  return {
    availability,
    deliveryWindowIds: current.deliveryWindowIds,
    deliveryWindowsSnapshot: current.deliveryWindowsSnapshot,
  };
};
